module.exports = __webpack_public_path__ + "img/ticket-cover.6fd1232a.png";